module.exports = __webpack_public_path__ + "media/hyper/images/payments/discover-f004eee2fea65301a4da669999e317a2.png";